module.exports = __webpack_public_path__ + "img/video-thumbnail.45e3a066.jpg";